class FbConversion {
    constructor(eventName) {
        this.event_name = eventName,
        this.event_id = null,
        this.action_sourc = 'website',
        this.event_time = null,
        this.user_data = {
            external_id: null,
            fbc: null,
            fbp: null,
            client_ip_address: null,
            client_user_agent: null,
            subscription_id: null,
        }
        this.custom_data = {},
        this.event_source_url = null
    }

    setId(eventId) {
        this.event_id = eventId;
    }

    setTime(timestamp) {
        this.event_time = timestamp;
    }

    setExternalId(value) {
        this.user_data.external_id = value;
    }

    setFbc(value) {
        this.user_data.fbc = value;
    }

    setFbp(value) {
        this.user_data.fbp = value;
    }

    setUrl(url) {
        this.event_source_url = url;
    }

    setUserAgent(value) {
        this.user_data.client_user_agent = value;
    }

    setSubscriptionId(value) {
        this.user_data.subscription_id = value;
    }

    get() {
        return this;
    }
}

export default FbConversion;